import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};
const { VALIDATE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'VocItemSuggestionsForSingleItemAgg',
    productArea: VOC,
    subProductArea: VALIDATE,
    responseFormat: 'rows',
    build: ({ type = 'idea', vocItemId, limit = 10 }) => {
        const idField = type === 'idea' ? 'leftId' : 'rightId';

        const pipeline = o.pipeline(
            o.sources.suggestions({
                state: 'pending',
                type: 'ideaAndFeedbackItem',
            }),
            o.filter(`${idField} == "${vocItemId}"`),
            o.sort('-score'),
            ...(limit ? [o.limit(limit)] : []),
        );

        return pipeline;
    },
};
